<div class="m-integerfield"
     :class="[{ 'm--is-disabled': isDisabled,
                'm--is-waiting': isWaiting,
                'm--is-readonly': isReadonly,
                'm--has-error': hasDecimalfieldError,
                'm--is-valid': isDecimalfieldValid,
                'm--has-label': hasLabel,
                'm--has-validation-message': hasValidationMessage } ]"
     @click="onClick"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }">
    <m-input-style :disabled="isDisabled"
                   :waiting="isWaiting"
                   :error="hasDecimalfieldError"
                   :valid="isDecimalfieldValid"
                   :label="label"
                   :label-for="id"
                   :focus="isFocus"
                   :label-up="labelUp"
                   :empty="isEmpty"
                   :readonly="isReadonly"
                   :required-marker="requiredMarker"
                   :tag-style="tagStyle">
        <template slot="prefix">
            <slot name="prefix"></slot>
        </template>
        <m-input-mask class="m-integerfield__input"
                      v-model="model"
                      :id="id"
                      :disabled="isDisabled || isWaiting"
                      :placeholder="placeholder"
                      :readonly="isReadonly"
                      :autocomplete="autocomplete"
                      @focus="onFocus"
                      @blur="onBlur"
                      @keyup="onKeyup"
                      @change="onChange"
                      ref="inputMask"
                      :options="inputMaskOptions"
                      inputmode="decimal"></m-input-mask>
        <template slot="suffix">
            <slot name="suffix"></slot>
        </template>
    </m-input-style>
    <div class="m-integerfield__validation">
        <m-validation-message class="m-integerfield__validation__message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasDecimalfieldError"
                              :error-message="errorMessage"
                              :valid="isDecimalfieldValid"
                              :valid-message="validMessage"
                              :helper-message="helperMessage"></m-validation-message>
    </div>
</div>
